import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import FindLaptop from '../../pages/FindLaptop'
import About from '../../pages/About';
import Welcome from '../../pages/Welcome';
import TechSupport from '../../pages/TechSupport'
import SingleLaptop from '../../pages/SingleLaptop';
import { backendURL } from '../../helper/constants';
import axios from 'axios';
import { Container } from 'react-bootstrap';
import {RenderIf} from '@alanngo/custom-components/dist';

const Home = () => {
  const [laptops, setLaptops] = useState([]);
  useEffect(() => axios.get(`${backendURL}/laptop/`).then(({ data }) => setLaptops(data)), []);

  return (
    <div className="">
      <Router>
        <Switch>
          <Route path="/laptops" exact>
            <Container fluid>
              <FindLaptop laptops={laptops} />
            </Container>
          </Route>
          <Route path="/laptop/:laptopId" >
            <Container fluid>
              <RenderIf condition={laptops.length>0}>
                <SingleLaptop laptops={laptops} />
              </RenderIf>
            </Container>
          </Route>
          <Route path="/techsupport" exact>
            <Container>
              <TechSupport />
            </Container>
          </Route>
          <Route path="/about" exact >
            <Container>
              <About/>
            </Container>
          </Route>
          <Route component={Welcome} path='*' />
        </Switch>
      </Router>
    </div>
  )
}




export default Home;